const chatRooms = [
    { id: 'pets', title: '🐶 Pets 🐈' },
    { id: 'comida', title: '🍔 Comida 🍔' },
    { id: 'assuntosGerais', title: '💬 Assuntos Gerais 💬' },
    { id: 'noticias', title: '🗞 Notícias 🗞' },
    { id: 'musica', title: '🎹 Música 🎹'},
    { id: 'esportes', title: '🏈 Esportes 🏈' },
    { id: 'programação', title: '💻 Programação 💻' },
    { id: 'contabilidade', title: '📊 Contabilidade 📊' },
    { id: 'religião', title: '✝️ Religião ✝️' },
    { id: 'política', title: '👨🏾‍💼 Política 👨🏾‍💼'},
]



export { chatRooms };

